import React from 'react';
import Modal from './Modal';
import PrimaryButton from './PrimaryButton';
import { useLang } from '../context/LangContext';

interface BidRestrictedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

// 국제화 텍스트
const bidRestrictedTexts = {
  ko: {
    header: '입찰이 제한되었습니다',
    body: '관리자의 권한으로 인해\n해당 경매의 입찰이 제한되었습니다',
    confirmButton: '확인'
  },
  en: {
    header: 'Bidding Restricted',
    body: 'Bidding in this auction has been\nrestricted by administrator authority',
    confirmButton: 'OK'
  }
};

const BidRestrictedModal: React.FC<BidRestrictedModalProps> = ({ isOpen, onClose }) => {
  const { lang } = useLang();
  const texts = bidRestrictedTexts[lang];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={texts.header}
      bgColor="white"
      body={texts.body}
      footer={
        <PrimaryButton onClick={onClose}>
          {texts.confirmButton}
        </PrimaryButton>
      }
    />
  );
};

export default BidRestrictedModal;